import React from "react";
import { useHistory } from "react-router-dom";
import { Typography, Paper, makeStyles, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: theme.spacing(3),
    textAlign: "center",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
    [theme.breakpoints.down("md")]: {
      width: "70%",
    },
  },
}));

const NotFound = () => {
  // Hooks
  const classes = useStyles();
  const history = useHistory();

  return (
    <Paper className={classes.root}>
      <Typography variant="h1">Oops</Typography>
      <h2>404 - Page not found</h2>

      <Typography variant="subtitle1">
        The page you are looking for might have been removed, had its name changed or is temporarily
        unavailable
      </Typography>

      <Button variant="outlined" className="mt-4" onClick={() => history.push("/")}>
        Go to home
      </Button>
    </Paper>
  );
};

export default NotFound;
